import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { IconButton, Typography } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PVS from './Pages/PVS';
import CR from './Pages/CR';
import PR from './Pages/PR';
import AR from './Pages/AR';
// import BR from './Pages/BR';
import LengthStayHistory from './Pages/LengthStayHistory';

const PatientReport = () => {
	const [PVSComponent, setPVSComponent] = useState(false);
	const [CRComponent, setCRComponent] = useState(false);
	const [PRComponent, setPRComponent] = useState(false);
	const [ARComponent, setARComponent] = useState(false);
	// const [BRComponent, setBRComponent] = useState(false);
	const [StayHistoryComponent, setStayHistoryComponent] = useState(false);
	const reports = [
		{
			title: 'Approved Visit History',
			icon: <AssignmentTurnedInIcon />,
			color: '#2E68BA',
			bg: '#edf3ff',
			onClick: () => setPVSComponent(true),
		},
		{
			title: 'Draft Visit History',
			icon: <DescriptionIcon />,
			color: '#25aee4',
			bg: '#eaf8ff',
			onClick: () => setARComponent(true),
		},
		{
			title: 'Patient Report',
			icon: <PersonIcon />,
			color: '#2e7de0',
			bg: '#f0f5ff',
			onClick: () => setPRComponent(true),
		},
		{
			title: 'Charges Report',
			icon: <AttachMoneyIcon />,
			color: '#2567d9',
			bg: '#eef3ff',
			onClick: () => setCRComponent(true),
		},
		{
			title: 'Length of Stay History',
			icon: <CalendarMonthIcon />,
			color: '#2567d9',
			bg: '#eef3ff',
			onClick: () => setStayHistoryComponent(true),
		},
	];

	return (
		<Box>
			{
				<Box>
					{PVSComponent ? (
						<PVS />
					) : CRComponent ? (
						<CR />
					) : PRComponent ? (
						<PR />
					) : ARComponent ? (
						<AR />
					) : // ) : BRComponent ? (
					// 	<BR />
					StayHistoryComponent ? (
						<LengthStayHistory />
					) : (
						<Paper
							sx={{
								m: 2,
								borderRadius: '8px',
								border: '1px solid #e3ebf6',
								boxShadow: '0 1px 4px rgba(16, 24, 40, 0.06)',
							}}
							elevation={0}
						>
							<Box
								sx={{
									flexGrow: 1,
									minHeight: {
										lg: '85vh',
										xs: 'auto',
									},
									p: 3,
								}}
							>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: 1.5,
										mb: 3,
									}}
								>
									<Box
										sx={{
											width: 6,
											height: 34,
											borderRadius: '999px',
											bgcolor: '#2E68BA',
										}}
									/>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: 700,
											color: '#172d58',
										}}
									>
										Select Report
									</Typography>
								</Box>
								<Grid
									container
									sx={{
										background: '#f8fbff',
										borderRadius: '8px',
										p: 2,
									}}
								>
									<Grid container item spacing={2.5}>
										{reports.map((report) => (
											<Grid item xs={12} sm={6} md={4} lg={2.4} key={report.title}>
												<Paper
													elevation={0}
													onClick={report.onClick}
													sx={{
														height: 260,
														borderRadius: '8px',
														border: '1px solid #e2eaf5',
														background: '#fff',
														boxShadow: '0 2px 7px rgba(16, 24, 40, 0.10)',
														cursor: 'pointer',
														position: 'relative',
														display: 'flex',
														flexDirection: 'column',
														alignItems: 'center',
														justifyContent: 'center',
														px: 2,
														transition: 'transform 160ms ease, box-shadow 160ms ease',
														'&:hover': {
															transform: 'translateY(-2px)',
															boxShadow: '0 8px 18px rgba(16, 24, 40, 0.12)',
														},
													}}
												>
													<Box
														sx={{
															width: 82,
															height: 82,
															borderRadius: '50%',
															bgcolor: report.bg,
															color: report.color,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															mb: 3,
															'& svg': { fontSize: 36 },
														}}
													>
														{report.icon}
													</Box>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '14px',
															fontWeight: 700,
															lineHeight: 1.35,
															textAlign: 'center',
															color: '#172033',
															maxWidth: 190,
														}}
													>
														{report.title}
													</Typography>
													<IconButton
														sx={{
															position: 'absolute',
															right: 22,
															bottom: 22,
															width: 44,
															height: 44,
															borderRadius: '50%',
															bgcolor: '#f3f7ff',
															color: '#0e579c',
															'&:hover': { bgcolor: '#e8f1ff' },
														}}
													>
														<ChevronRightIcon />
													</IconButton>
												</Paper>
											</Grid>
										))}
									</Grid>
								</Grid>
							</Box>
						</Paper>
					)}
				</Box>
			}
		</Box>
	);
};

export default PatientReport;
